// extracted by mini-css-extract-plugin
export default {"container":"DphLAk","description":"OMdnp2"};